import { frozen } from "mobx-keystone";
import { Cubby } from "../stores/Cubby";
import { decode } from "@gandlaf21/bolt11-decode";
import { notifications } from "@mantine/notifications";

export const payToLightningAddressInvoice = async (
  cubby: Cubby,
  unValidatedPayRequest: string,
  intendedSatoshisAmount: number,
  hTagMustMatch: string,
  twoFACode: string
) => {
  console.log("must validate invoice amount and htag ");
  console.log("unValidatedPayRequest:", unValidatedPayRequest);
  console.log("intendedSatoshisAmount:", intendedSatoshisAmount);
  console.log("hTagMustMatch:", hTagMustMatch);
  const decodedPayRequest = decode(unValidatedPayRequest);
  console.log("decodedPayRequest:", decodedPayRequest);
  const satoshisValueOfInvoice = decodedPayRequest.sections[2].value / 1000;
  console.log("satoshisValueOfInvoice:", satoshisValueOfInvoice);
  if (satoshisValueOfInvoice !== intendedSatoshisAmount) {
    console.log("invoice amount does not match intended amount");
    notifications.show({
      color: "red",
      title: "Error",
      message: "invoice amount does not match intended amount",
    });
    return;
  }

  const dataHash = {
    amountInSatoshis: null,
    outgoingChannelScid: null,
    maxFee: null,
    pathFindingTimeout: null,
    payRequest: unValidatedPayRequest,
    twoFAcode: twoFACode,
  };
  cubby.cubbyLife("dangerous_pay_invoice", dataHash);
};
